<div class="layout-dashboard" [class.sem-filtros]="!filtrosVisiveis">
    @if (filtrosVisiveis) {
        <aside class="coluna-filtros">
            <section class="painel-filtros-atividades">
                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('id')" [attr.aria-expanded]="!blocosColapsados.id">
                        <h3>Id</h3>
                        <i [class]="iconeColapso('id')"></i>
                    </button>
                    @if (!blocosColapsados.id) {
                        <div class="conteudo-bloco">
                            <input id="filtro-id" pInputText type="text" [(ngModel)]="filtrosEdicao.id" (ngModelChange)="aplicarFiltros()" />
                        </div>
                    }
                </article>

                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('nomeMedico')" [attr.aria-expanded]="!blocosColapsados.nomeMedico">
                        <h3>Nome do Médico</h3>
                        <i [class]="iconeColapso('nomeMedico')"></i>
                    </button>
                    @if (!blocosColapsados.nomeMedico) {
                        <div class="conteudo-bloco">
                            <input id="filtro-nome" pInputText type="text" [(ngModel)]="filtrosEdicao.nomeMedico" (ngModelChange)="aplicarFiltros()" />
                        </div>
                    }
                </article>

                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('crm')" [attr.aria-expanded]="!blocosColapsados.crm">
                        <h3>CRM</h3>
                        <i [class]="iconeColapso('crm')"></i>
                    </button>
                    @if (!blocosColapsados.crm) {
                        <div class="conteudo-bloco">
                            <input id="filtro-crm" pInputText type="text" [(ngModel)]="filtrosEdicao.crm" (ngModelChange)="aplicarFiltros()" />
                        </div>
                    }
                </article>

                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('cpf')" [attr.aria-expanded]="!blocosColapsados.cpf">
                        <h3>CPF</h3>
                        <i [class]="iconeColapso('cpf')"></i>
                    </button>
                    @if (!blocosColapsados.cpf) {
                        <div class="conteudo-bloco">
                            <input id="filtro-cpf" pInputText type="text" [(ngModel)]="filtrosEdicao.cpf" (ngModelChange)="aplicarFiltros()" />
                        </div>
                    }
                </article>

                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('ufOrigem')" [attr.aria-expanded]="!blocosColapsados.ufOrigem">
                        <h3>UF Origem</h3>
                        <i [class]="iconeColapso('ufOrigem')"></i>
                    </button>
                    @if (!blocosColapsados.ufOrigem) {
                        <div class="conteudo-bloco">
                            <input id="filtro-uf-origem" pInputText type="text" maxlength="2" [(ngModel)]="filtrosEdicao.ufOrigem" (ngModelChange)="aplicarFiltros()" />
                        </div>
                    }
                </article>

                <article class="bloco-filtro">
                    <button type="button" class="cabecalho-bloco" (click)="alternarColapso('tipo')" [attr.aria-expanded]="!blocosColapsados.tipo">
                        <h3>Tipo</h3>
                        <i [class]="iconeColapso('tipo')"></i>
                    </button>
                    @if (!blocosColapsados.tipo) {
                        <div class="conteudo-bloco">
                            <p-select id="filtro-tipo" [options]="opcoesTipo" optionLabel="label" optionValue="value" appendTo="body" [(ngModel)]="filtrosEdicao.tipo" (onChange)="aplicarFiltros()"></p-select>
                        </div>
                    }
                </article>

                <div class="acoes-filtro">
                    <button type="button" pButton label="Restaurar Filtros" severity="secondary" [outlined]="true" (click)="restaurarFiltros()"></button>
                    <button type="button" pButton label="Limpar Filtros" severity="secondary" [outlined]="true" (click)="limparFiltros()"></button>
                </div>
            </section>
        </aside>
    }

    <section class="coluna-conteudo">
        <app-card-content [icon]="'pi pi-inbox'" [title]="'Abertas por UF Destino'" [subtitle]="'Medicos de outros estados que solicitaram movimentacao para o CRM ' + (ufDestino ? '-' + ufDestino : '')">
            <div card-header class="transferencias-card-acoes">
                @if (solicitacaoSelecionada && podeExibirAcoes()) {
                    <app-botao-acoes label="Ações" [iconPos]="EInconPos.LEFT" [items]="itensAcoesMenu" [iconColumns]="2"></app-botao-acoes>
                }
                <div class="flex items-center gap-2">
                    <button pButton type="button" icon="pi pi-filter" class="p-button-sm p-button-text" [label]="filtrosVisiveis ? 'Ocultar filtros' : 'Mostrar filtros'" (click)="alternarFiltros()"></button>
                    <button pButton type="button" icon="pi pi-refresh" class="p-button-sm p-button-text" label="Atualizar" (click)="carregarAbertasUfDestino()"></button>
                </div>
            </div>

            <div class="grid-indicadores">
                <div class="stat-card">
                    <div class="stat-info">
                        <span class="stat-rotulo">Total de Solicitações</span>
                        <span class="stat-valor">{{ totalSolicitacoes }}</span>
                    </div>
                </div>

                <div class="stat-card stat-card--success">
                    <div class="stat-info">
                        <span class="stat-rotulo">Transferências (T)</span>
                        <span class="stat-valor">{{ totalTransferencias }}</span>
                    </div>
                </div>

                <div class="stat-card stat-card--warning">
                    <div class="stat-info">
                        <span class="stat-rotulo">Inscrições Secundárias (S)</span>
                        <span class="stat-valor">{{ totalSecundarias }}</span>
                    </div>
                </div>

                <div class="stat-card stat-card--danger">
                    <div class="stat-info">
                        <span class="stat-rotulo">Validade Vencida</span>
                        <span class="stat-valor">{{ totalVencidos }}</span>
                    </div>
                </div>
            </div>

            <p-confirmDialog [style]="{ width: '26rem' }"></p-confirmDialog>

            @if (feedbackAcao) {
                <div class="abertas-feedback" [class.erro]="erroAcao">{{ feedbackAcao }}</div>
            }

            @if (carregando()) {
                <div class="abertas-feedback">Carregando solicitações...</div>
            } @else if (erroConsulta) {
                <div class="abertas-feedback erro">{{ erroConsulta }}</div>
            } @else if (!solicitacoes.length) {
                <div class="abertas-feedback">Nenhuma solicitação aberta encontrada para a UF de destino.</div>
            } @else if (!solicitacoesFiltradas.length) {
                <div class="abertas-feedback">Nenhum resultado encontrado para os filtros informados.</div>
            } @else {
                <!--
                    `cardColumns=2`, e não os três do padrão: a grade de detalhes dentro do cartão é
                    `auto-fit minmax(190px)`, e com três cartões por linha cada um fica em 389px — logo
                    abaixo do limiar de duas colunas. Os campos empilhavam numa coluna só, com 407px de
                    altura. Com dois por linha o cartão vai a 592px, a grade abre em duas colunas e a
                    altura cai para 269px.
                -->
                <app-custom-table
                    [data]="solicitacoesFiltradasTabela"
                    [metadata]="metadataTabela"
                    [loading]="carregando()"
                    [first]="first"
                    [rows]="rows"
                    [totalRecords]="totalSolicitacoes"
                    [rowClickable]="true"
                    [showExpandButton]="false"
                    [showActions]="false"
                    [initialViewMode]="'table'"
                    [cardColumns]="2"
                    [useCustomCard]="true"
                    (onRowClick)="onSelecaoAlterada($event)"
                    (onPageChange)="onPageChange($event)"
                >
                    <!--
                        Única coluna sob medida: o badge do protocolo fica ACIMA do nome, e o tipo
                        `perfil` do CustomTable desenha só retrato e nome. As demais colunas saem do
                        metadata. O desenho do bloco vive em `app-identificacao-pessoa`, um só para
                        as três abas.
                    -->
                    <ng-template pTemplate="cell" let-rowData="rowData" let-column="column">
                        @switch (column.key) {
                            @case ('medicoPerfil') {
                                <app-identificacao-pessoa
                                    [foto]="rowData.medicoPerfil?.foto ?? null"
                                    [iniciais]="rowData.medicoPerfil?.iniciais ?? null"
                                    [nome]="rowData.medicoPerfil?.nome || metadataTabela.headers['medicoPerfil'].default"
                                    [protocolo]="rowData.idSolicitacaoStr"
                                    [inscricao]="rowData.crmUfChip"
                                />
                            }
                            @case ('dataSolicitacaoStr') {
                                <app-vigencia-solicitacao [solicitacao]="rowData.dataSolicitacaoStr" [validade]="rowData.dataValidadeTag?.value" [severidade]="rowData.dataValidadeTag?.severity" />
                            }
                            @case ('ufOrigemStr') {
                                <app-bandeira-uf [uf]="rowData.ufOrigemStr" />
                            }
                        }
                    </ng-template>
                    <!--
                        O card espelha a tabela: mesmo bloco de identificação e mesmos selos de
                        vigência. Convive com o `pTemplate="cell"` acima — o CustomTable recolhe os
                        dois no mesmo `@ContentChildren` e os separa por tipo.

                        Sem `(click)` aqui: o CustomTable já embrulha este template num elemento com
                        o clique de seleção. Um clique próprio marcaria e desmarcaria a linha no
                        mesmo gesto.
                    -->
                    <ng-template pTemplate="card" let-rowData let-selected="selected">
                        <app-cartao-transferencia [linha]="rowData" [rotuloUf]="metadataTabela.headers['ufOrigemStr'].value" [valorUf]="rowData.ufOrigemStr" [selecionado]="!!selected" />
                    </ng-template>
                </app-custom-table>
            }
        </app-card-content>
    </section>
</div>

<p-dialog
    appDialogoPadrao="pi pi-check-circle"
    descricao="Aguarde: a transferência está sendo confirmada."
    [(visible)]="dialogLoadingConfirmacaoVisivel"
    [closable]="false"
    [closeOnEscape]="false"
    [style]="{ width: '26rem' }"
    header="Processando confirmação"
>
    <div class="correspondencia-feedback">Aguarde, estamos processando o cadastro e a confirmação...</div>
</p-dialog>

<p-dialog appDialogoPadrao="pi pi-id-card" descricao="Número de inscrição atribuído ao médico." [(visible)]="dialogCrmGeradoVisivel" [style]="{ width: '28rem' }" header="CRM gerado" (onHide)="fecharDialogCrmGerado()">
    <p>
        Confirmação concluída.<br />
        CRM gerado: <strong>{{ crmGeradoConfirmacao }}/{{ ufCrmGeradoConfirmacao }}</strong>
    </p>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Transferência de inscrição entre UFs."
    [(visible)]="dialogCorrespondenciaVisivel"
    [maximizable]="true"
    [style]="{ width: '90vw', maxWidth: '1100px' }"
    [contentStyle]="{ 'max-height': '75vh', overflow: 'auto' }"
    [header]="dialogTitulo"
    (onHide)="fecharDialogCorrespondencia()"
>
    @if (dialogCarregando()) {
        <div class="correspondencia-feedback">Carregando correspondências...</div>
    } @else if (dialogErro) {
        <div class="correspondencia-feedback erro">{{ dialogErro }}</div>
    } @else {
        <div class="correspondencia-lista">
            @if (certificadoPdfUrl) {
                <section class="correspondencia-item">
                    <h3>Certificado de Regularidade</h3>
                    <iframe [src]="certificadoPdfUrl" class="certificado-pdf-iframe"></iframe>
                </section>
            }
            @for (correspondencia of correspondenciasHtml; track correspondencia.titulo) {
                <section class="correspondencia-item">
                    <h3>{{ correspondencia.titulo }}</h3>
                    <div class="correspondencia-html" [innerHTML]="correspondencia.html"></div>
                </section>
            }
        </div>
    }
</p-dialog>
